"use client";
import { PropsWithChildren } from "react";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider as RqQueryClientProvider,
} from "@tanstack/react-query";

const queryCache = new QueryCache();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  },
  queryCache,
});

export default function QueryClientProvider({
  children,
}: PropsWithChildren<{}>) {
  return (
    <RqQueryClientProvider client={queryClient}>
      {children}
    </RqQueryClientProvider>
  );
}
